export const SERVICES = [
  {
    key: "software",
    index: "01",
    title: "Software & Web Development",
    tagline: "Products engineered to ship.",
    desc: "Full-stack web & mobile apps, custom platforms and APIs built with modern stacks — designed to scale from MVP to millions.",
    points: ["Web & mobile apps", "Custom platforms & APIs", "UI/UX engineering", "MVP to scale"],
  },
  {
    key: "consulting",
    index: "02",
    title: "IT Consulting & Support",
    tagline: "Your technology, handled.",
    desc: "Strategy, architecture reviews and always-on managed support that keeps your systems secure, reliable and future-ready.",
    points: ["Digital strategy", "Architecture reviews", "24/7 managed support", "Security audits"],
  },
  {
    key: "cloud",
    index: "03",
    title: "Cloud & DevOps",
    tagline: "Infrastructure that never sleeps.",
    desc: "Cloud migration, CI/CD pipelines and infrastructure-as-code that automate delivery and cut costs across AWS, GCP & Azure.",
    points: ["Cloud migration", "CI/CD automation", "Kubernetes & IaC", "Cost optimization"],
  },
];

export const PROCESS = [
  { n: "01", title: "Discover", desc: "We dig into your goals, users and constraints to define what winning looks like." },
  { n: "02", title: "Design", desc: "We architect the system and craft interfaces that feel inevitable, not decorative." },
  { n: "03", title: "Build", desc: "Tight iterations, clean code and continuous delivery — you see progress every week." },
  { n: "04", title: "Scale", desc: "We harden, monitor and optimize so your product grows without breaking." },
];

export const WORK = [
  {
    title: "FinEdge Analytics",
    cat: "Software Development",
    desc: "Real-time trading analytics dashboard processing millions of events per second.",
    img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80",
  },
  {
    title: "Nimbus Cloud Ops",
    cat: "Cloud & DevOps",
    desc: "Zero-downtime multi-region infrastructure with automated CI/CD across teams.",
    img: "https://images.unsplash.com/photo-1720962158813-29b66b8e23e1?w=1200&q=80",
  },
  {
    title: "Helix Consulting Suite",
    cat: "IT Consulting",
    desc: "Enterprise modernization program migrating legacy systems to a modular cloud core.",
    img: "https://images.unsplash.com/photo-1579567761406-4684ee0c75b6?w=1200&q=80",
  },
];

export const STATS = [
  { value: "120+", label: "Projects shipped" },
  { value: "40+", label: "Global clients" },
  { value: "99.9%", label: "Uptime delivered" },
  { value: "8yrs", label: "Avg. engineer experience" },
];
